import React from 'react';
import AuthDispatchContext from './AuthDispatchContext';
import AuthStateContext from './AuthStateContext';
import jwtDecode from 'jwt-decode';

function parse(value) {
    if (!value) {
        return null;
    }
    var decoded = jwtDecode(value);
    return {
        token : value,
        expired : () => {
            let expired = true;
            if (typeof decoded.exp !== 'undefined') {
                const now = Date.now().valueOf() / 1000;
                if (now < decoded.exp) {
                    expired = false;
                }
            }
            return expired;
        },
        decoded : decoded,
    }
}

const initialState = {};

function initialize() {
    return parse(sessionStorage.getItem('token'));
}

function reducer(state, action) {
    switch(action.type) {
        case "SET": {
            sessionStorage.setItem('token', action.value);
            return parse(action.value);
        }
        default:
            return state;
    }
}

export default function AuthProvider(props)
{
  const [state, dispatch] = React.useReducer(reducer, initialState, initialize);

  return (
    <AuthDispatchContext.Provider value={dispatch}>
        <AuthStateContext.Provider value={state}>
            {props.children}
        </AuthStateContext.Provider>
    </AuthDispatchContext.Provider>
  );
}